import React from 'react';
import ReactDOM from 'react-dom/client';

// Wave-5 fix 5.x.5 / UI-review T-1. Load Inter via @fontsource so the
// SPA renders in the actual brand typeface instead of the platform
// fallback (Helvetica/Arial). Both Latin AND Cyrillic subsets are
// imported because the UI is bilingual (Q54 — Russian text MUST also
// render in Inter; otherwise headers shift to a system Cyrillic face
// and the warm-theme reference breaks). Inter ships separate per-subset
// css files; importing both ensures all 4xx weights load with the right
// `unicode-range` declarations.
import '@fontsource/inter/latin.css';
import '@fontsource/inter/cyrillic.css';

// Fraunces 600 powers the official wordmark "АРИС · Платформа" in
// <BrandMark withText> (design-reference L443-447). Fraunces ships
// Latin-only — Cyrillic gracefully falls back to the system serif,
// matching exactly what the reference HTML produces in a browser.
import '@fontsource/fraunces/600.css';

import { z } from 'zod';
import { ruZodErrorMap } from '@aris/shared';

import { App } from './App';
import './styles/globals.css';

// Русские тексты вместо английских дефолтов zod — ставятся на ТОТ экземпляр
// zod, который резолвит сам веб.
//
// ЗАЧЕМ ОТДЕЛЬНО, если `@aris/shared` ставит карту побочным эффектом импорта.
// zod 3.25 — двойной пакет: `"import": "./index.js"` (ESM) и
// `"require": "./index.cjs"` (CJS). Это ДВА модуля со своим состоянием, и
// глобальная карта у каждого своя. `@aris/shared` собран только под CommonJS
// (`module: "CommonJS"`, поля `exports` нет), поэтому его установка ложится
// на CJS-экземпляр. Веб — ESM, и его собственные схемы (формы объявляют их
// прямо в компонентах на голом `z`) могут оказаться на другом экземпляре.
//
// Сегодня сборка сводит оба к одному, и потому дефект латентный — но
// опираться на это нельзя. `ruZodErrorMap` — обычная функция и от экземпляра
// не зависит, поэтому ставим её здесь через импорт самого веба. Стоит копейки
// и снимает зависимость от того, как сборщик разрешит двойной пакет.
z.setErrorMap(ruZodErrorMap);

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
